import React, { useContext, useEffect, useState } from "react";
import { useRouterParams } from "../../../abstracts";
import {
  FieldInput,
  ManageMapperLayout,
  FieldDropSide,
  SearchableList,
  LoaderWrapper,
} from "../../../components";
import { Form, Button } from "react-bootstrap";
import { Field, Formik, ErrorMessage } from "formik";
import { Card } from "react-bootstrap";
import ManageAddPlanButton from "./ManageAddPlanButton";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  MANAGE_MAPPER_POST_API_REQUEST,
  MANAGE_MAPPER_POST_API_RESPONSE,
  setBasicInformation,
  setManageMapperFlow,
  setManageMapperToastInfo,
} from "../../../contexts";
import { get, isEmpty, trim } from "lodash-es";
import {
  onProfileNameChange,
  checkProfileNameExists,
  saveBasicInformation,
  outputSaveBasicInformation,
} from "../../../services";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
  required,
} from "../../../utils";
import * as Yup from "yup";
import PlanGroupSlider from "./PlanGroupSlider";
import MappedPlanGroupCard from "../MapAndTransformOutput/MappedPlanGroupCard";
import MappedPlanGroupSlider from "../MapAndTransformOutput/MappedPlanGroupSlider";
import { passthroughSaveBasicInformation } from "./../../../services/mapper/index";
const initialValues = {};

const typeOptions = [
  { value: 1, label: "Input Type" },
  { value: 2, label: "Output Type" },
  { value: 3, label: "Passthrough" },
];

const typeOptionsForDataModel = [
  { value: 3, label: "Payroll and Census" },
  { value: 1, label: "Payroll" },
  { value: 2, label: "Census" },
];

const typeOptionsForProfileLevel = [
  { value: 1, label: "Plan Level" },
  { value: 2, label: "Global" },
  { value: 3, label: "Plan Group" },
];

const LoadDefHomeContainer = (props) => {
  const { flow, profileId, mapType } = useRouterParams();
  const formNameSource = manageMapperFormNames.SOURCE;
  const { state, dispatch } = useContext(manageMapperStore);
  const [dataLoading, setDataLoading] = useState(false);
  const isEdit = flow === FLOW_TYPES.EDIT || profileId;
  const formName = manageMapperFormNames.BASIC_INFORMATION;
  const fields = mapperFormFields[formName];
  const data = get(state, "api.data", {}) || get(state, "basicInformation", {});
  const apiOutput = get(data, "isOutput", false);
  const planProfiles = get(state, "api.data.planProfiles", []);
  const outputPlanProfiles = get(state, "api.data.outputPlanProfiles", []);
  const planGroupProfiles = get(state, "api.data.planGroupProfiles", []);
  const outputPlanGroupsProfiles = get(
    state,
    "api.data.outputPlanGroupProfileMappings",
    []
  );
  const [savedPlans, setSavedPlans] = useState([]);
  const [savedPlanGroups, setSavedPlangroups] = useState([]);
  const [showSlider, setShowSlider] = useState(false);
  const [slideout, setSlideOut] = useState(false);
  const [planGroupId, setPlanGroupId] = useState(null);
  const [addedPlanGroups, setAddedPlanGroups] = useState([]);
  useEffect(() => {
    if (!isEmpty(planProfiles)) {
      setSavedPlans(planProfiles);
    }
  }, [planProfiles, isEdit]);
  useEffect(() => {
    if (!isEmpty(outputPlanProfiles)) {
      setSavedPlans(outputPlanProfiles);
    }
  }, [outputPlanProfiles, isEdit]);

  useEffect(() => {
    if (!isEmpty(outputPlanGroupsProfiles)) {
      setSavedPlangroups(outputPlanGroupsProfiles);
    }
  }, [outputPlanGroupsProfiles, isEdit]);

  useEffect(() => {
    if (!isEmpty(planGroupProfiles)) {
      setSavedPlangroups(planGroupProfiles);
    }
  }, [planGroupProfiles, isEdit]);

  const style = {
    dropdownIndicator: (provided) => ({
      ...provided,
      svg: {
        fill: "black",
      },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };
  const [nameExists, setNameExists] = useState("");

  const ValidationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("Required")
      .max(150, "Map name should not exceed above 150 characters"),
    mapType: Yup.string().required("Required"),
  });
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  const [errorMsg, setErrorMsg] = useState("");
  const apiCall = (payload) => {
    if (payload.mapType == 2) {
      return outputSaveBasicInformation(payload);
    } else if (payload.mapType == 3) {
      return passthroughSaveBasicInformation(payload);
    } else return saveBasicInformation(payload);
  };

  const onFormSubmit = (
    values,
    { setSubmitting, setFieldError, setFieldTouched }
  ) => {
    const { history } = props;
    setDataLoading(true);
    setSubmitting(true);
    const data = get(state, "api.data", {});
    const idName = 0;
    const mapName = trim(values[fields.mapName]);

    checkProfileNameExists(idName, mapName)
      .then((response) => {
        setDataLoading(false);
        setNameExists(response);
        if (response && !isEdit) {
          setErrorMsg("Map name already exists");
        } else if (
          isEdit &&
          response &&
          values[fields.mapName] !== get(state, "api.data.name", "")
        ) {
          setErrorMsg("Map name already exists");
        } else {
          setErrorMsg("");
          if (
            !isEmpty(data) &&
            values[fields.mapName] !== get(state, "api.data.name", "")
          ) {
            onProfileNameChange({ ...data, name: get(values, "name") })
              .then((res) => {
                if (!isEmpty(res)) {
                  dispatch({
                    type: MANAGE_MAPPER_POST_API_RESPONSE,
                    payload: res,
                  });
                  if(data?.mapType != 1){
                    values[fields.mapType] == 2
                    ? history.push(
                        getPathWithParam({
                          path: MANAGE_MAPPER_ROUTES.OUTPUT_TARGET,
                          pathParam: [flow, values[fields.mapType], profileId],
                        })
                      )
                    : history.push(
                        getPathWithParam({
                          path: MANAGE_MAPPER_ROUTES.SOURCE,
                          pathParam: [flow, values[fields.mapType], profileId],
                        })
                      );
                  }
                }
              })
              .catch((err) => {
                setDataLoading(false);
                dispatch({
                  type: MANAGE_MAPPER_POST_API_ERROR,
                  payload: "Something went wrong! please try again.",
                });
              });
          }
          if (!profileId && !isEmpty(values[fields.mapName]) && !apiOutput) {
            const plans = savedPlans.map((e) => e.planId.toString());
            dispatch({
              type: MANAGE_MAPPER_POST_API_REQUEST,
            });
            const planGroupsPayload = savedPlanGroups.map((item, index) => {
              return {
                id: item.id ?? 0,
                mappingOutputProfileId: profileId,
                planGroupId: item.planGroupId,
                planGroupName: item.planGroupName,
                planGroupDescription: item.planGroupDescription,
                count: item.count,
              };
            });
            let payload = {
              name: values?.name,
              mapType: values?.mapType ? values?.mapType : null,
              isOutput: apiOutput,
              planProfileMappings: savedPlans,
              planGroupProfileMappings: planGroupsPayload,
              createdBy: 1,
              id: profileId || 0,
            };
            if (values?.mapType == 2)
              payload = {
                ...payload,
                dataModel: values?.dataModel,
                profileLevel: values?.profileLevel,
                outputPlanProfiles: savedPlans,
                outputPlanGroupProfileMappings: planGroupsPayload,
              };
            else if (values?.mapType == 3)
              payload = {
                name: values?.name,
                mapType: values?.mapType ? values?.mapType : null,
                createdBy: 1,
                id: profileId || 0,
              };
            apiCall(payload)
              .then((response) => {
                dispatch({
                  type: MANAGE_MAPPER_POST_API_RESPONSE,
                  payload: response,
                });
                dispatch(
                  setManageMapperToastInfo({
                    showToast: true,
                    toastMessage: "Data saved successfully",
                  })
                );
                !isEmpty(plans)
                  ? dispatch(
                      setBasicInformation({
                        ...values,
                        planProfileMappings: savedPlans,
                        planGroupProfileMappings: savedPlanGroups,
                        outputPlanProfiles: savedPlans,
                        outputPlanGroupProfileMappings: savedPlanGroups,
                      })
                    )
                  : dispatch(setBasicInformation({ ...values }));
                values[fields.mapType] == 3 &&
                  history.push(
                    getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.SOURCE,
                      pathParam: [
                        flow,
                        values[fields.mapType],
                        response?.id || profileId,
                      ],
                    })
                  );
                values[fields.mapType] == 2
                  ? history.push(
                      getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.OUTPUT_TARGET,
                        pathParam: [
                          flow,
                          values[fields.mapType],
                          response?.id || profileId,
                        ],
                      })
                    )
                  : history.push(
                      getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.SOURCE,
                        pathParam: [
                          flow,
                          values[fields.mapType],
                          response?.id || profileId,
                        ],
                      })
                    );
              })
              .catch((error) => {
                dispatch({
                  type: MANAGE_MAPPER_POST_API_ERROR,
                  payload: "Something went wrong! please try again.",
                });
              });
          }
          if (isEdit) {
            values[fields.mapType] == 2
              ? apiOutput
                ? history.push(`${ROUTES.MAPPER_HOME}`)
                : history.push(
                    getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.OUTPUT_TARGET,
                      pathParam: [flow, values[fields.mapType], profileId],
                    })
                  )
              : history.push(
                  getPathWithParam({
                    path: MANAGE_MAPPER_ROUTES.SOURCE,
                    pathParam: [flow, values[fields.mapType], profileId],
                  })
                );
          }
        }
      })
      .catch((err) => {
        // alert("api error");
        setDataLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };

  const onPlanGroupClick = (id) => {
    setPlanGroupId(id);
    setSlideOut(true);
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.mapName]: get(data, "name", ""),
        [fields.dataModel]: get(data, "dataModel", 3),
        [fields.profileLevel]: get(data, "profileLevel", 1),
        [fields.mapType]:
          data?.mapType == 1 && apiOutput ? 2 : get(data, "mapType") || 1,
        // [fields.mapType]: apiOutput ? 1 : 0,
      }}
      enableReinitialize
      onSubmit={onFormSubmit}
      validationSchema={ValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
      }) => {
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(errors)}
          >
            <ManageMapperLayout buttons={buttons} planProfiles={planProfiles}>
              <LoaderWrapper isLoading={dataLoading}>
                <div>
                  <Field
                    type="text"
                    name={fields.mapName}
                    placeholder={"Enter the Map name"}
                    label={"Map Name"}
                    component={FieldInput}
                    disabled={
                      (parseInt(profileId) < 89 && parseInt(mapType) === 1) ||
                      !isEmpty(get(state, formNameSource, []))
                    }
                    isRequired
                    // validate={(value)=>ifNameExists(value)}
                    onKeyPress={(event) => {
                      const { key } = event;
                      if (key === "/" || key === "\\") {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event) => {
                      const clipboardData =
                        event.clipboardData || window.clipboardData;
                      console.log("clipboardData", clipboardData);
                      const pastedText = clipboardData.getData("text/plain");
                      if (
                        pastedText.includes("/") ||
                        pastedText.includes("\\")
                      ) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <div
                    style={{
                      fontSize: "0.75rem",
                      marginTop: "-0.75rem",
                      paddingTop: "0rem",
                      // border:"1px solid blue",
                      color: "#ff5050",
                      // height:"1rem"
                    }}
                  >
                    {errorMsg}
                  </div>
                </div>

                <div
                  style={{
                    width: "20rem",
                    fontSize: "12px",
                    // font: "Poppins",
                    fontWeight: "400",
                    paddingBottom: "1rem",
                    paddingTop: "1rem",
                    // border:"1px solid pink"
                  }}
                >
                  <Field
                    name={fields.mapType}
                    label={"Map type"}
                    value={values[fields.mapType]}
                    options={typeOptions}
                    isRequired
                    direction={"bottom"}
                    disabled={
                      isEdit || !isEmpty(get(state, formNameSource, []))
                    }
                    popupContent={
                      <SearchableList
                        label="Map type"
                        isNotTypeAhead
                        options={typeOptions}
                        onSelect={(value) => {
                          setFieldValue(fields.mapType, value);
                          dispatch(setManageMapperFlow({ mapType: value }));
                        }}
                        selectedValue={values[fields.mapType]}
                      />
                    }
                    component={FieldDropSide}
                  />

                  {values[fields.mapType] == 2 && (
                    <Field
                      name={fields.dataModel}
                      label={"Data Model"}
                      value={values[fields.dataModel]}
                      options={typeOptionsForDataModel}
                      isRequired
                      validate={values[fields.mapType] == 2 && required}
                      direction={"bottom"}
                      disabled={
                        isEdit || !isEmpty(get(state, formNameSource, []))
                      }
                      popupContent={
                        <SearchableList
                          label="Data Model"
                          isNotTypeAhead
                          options={typeOptionsForDataModel}
                          onSelect={(value) =>
                            setFieldValue(fields.dataModel, value)
                          }
                          selectedValue={values[fields.dataModel]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  )}

                  {/* {values[fields.mapType] == 2 && (
                    <Field
                      name={fields.profileLevel}
                      label={"Profile Level"}
                      value={values[fields.profileLevel]}
                      options={typeOptionsForProfileLevel}
                      isRequired
                      validate={values[fields.mapType] == 2 && required}
                      direction={"bottom"}
                      disabled={
                        isEdit || !isEmpty(get(state, formNameSource, []))
                      }
                      popupContent={
                        <SearchableList
                          label="Profile Level"
                          isNotTypeAhead
                          options={typeOptionsForProfileLevel}
                          onSelect={(value) =>
                            setFieldValue(fields.profileLevel, value)
                          }
                          selectedValue={values[fields.profileLevel]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  )} */}
                </div>
                {/* <pre>{JSON.stringify(nameExists, null, 2)}</pre> */}
                {values[fields.mapType] != 3 && (
                  <div style={{ height: "100%" }}>
                    <div
                      style={{
                        fontWeight: "500",
                        marginBottom: "1rem",
                        fontSize: "18px",
                      }}
                    >
                      Associate Plans
                    </div>
                    <Card className="PlansAssociatedCard">
                      <div style={{ fontSize: "16px", fontWeight: "400" }}>
                        Plans associated
                      </div>
                      <div>
                        {/* <div className="NumOfPlans" id="NumberOfPlansAdded"> */}
                        {/* {!isEmpty(savedPlans) && savedPlans.length } */}
                        {isEmpty(savedPlans) ? (
                          <div className="NumOfPlans" id="NumberOfPlansAdded">
                            0
                          </div>
                        ) : (
                          <div className="NumOfPlans" id="NumberOfPlansAdded">
                            {savedPlans.length}
                          </div>
                        )}

                        <div style={{ display: "flex", marginTop: "0px" }}>
                          <div
                            className="AddedPlansText"
                            style={{ marginTop: "10px", width: "100px" }}
                          >
                            Added plans
                          </div>
                          {!isEdit ? (
                            <ManageAddPlanButton
                              savedPlans={savedPlans}
                              setSavedPlans={setSavedPlans}
                              planProfiles={
                                data?.mapType == 1
                                  ? planProfiles
                                  : outputPlanProfiles
                              }
                              mappingConfigurationId={profileId}
                              mapType={values[fields.mapType]}
                              isEdit={isEdit}
                              apiOutput={apiOutput}
                            />
                          ) : (
                            <ManageAddPlanButton
                              savedPlans={savedPlans}
                              setSavedPlans={setSavedPlans}
                              planProfiles={
                                data?.mapType == 1
                                  ? planProfiles
                                  : outputPlanProfiles
                              }
                              mappingConfigurationId={get(state, "api.data.id")}
                              isEdit={isEdit}
                              mapType={values[fields.mapType]}
                              mappedPlans={
                                data?.mapType == 1
                                  ? get(state, "api.data.planProfiles")
                                  : get(state, "api.data.outputPlanProfiles")
                              }
                              apiOutput={apiOutput}
                            />
                          )}
                        </div>
                      </div>
                    </Card>

                    <div className="d-flex mt-4 justify-content-space-between align-items-baseline">
                      <div>
                        <p className="PlanGroupHeader mb-1">Plan Group </p>
                        <p className="recordCount">
                          {savedPlanGroups?.length} records
                        </p>
                      </div>
                      <div className="mr-3">
                        <Button
                          variant="secondary"
                          onClick={() => setShowSlider(true)}
                        >
                          Add Group
                        </Button>
                      </div>
                    </div>
                    <div className="border-line-seperator mb-3" />
                    <PlanGroupSlider
                      savedPlanGroups={savedPlanGroups}
                      setSavedPlangroups={setSavedPlangroups}
                      showSlider={showSlider}
                      setShowSlider={setShowSlider}
                      mappingConfigurationId={profileId}
                      mapType={values[fields.mapType]}
                      addedPlanGroups={addedPlanGroups}
                      setAddedPlanGroups={setAddedPlanGroups}
                      apiOutput={apiOutput}
                    />

                    <div
                      className="d-flex flex-column"
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        style={{
                          width: "100%",
                          flex: "1 1 auto",
                          display: "flex",
                          flexWrap: "wrap",
                          marginLeft: "0px",
                        }}
                        className="mb-5"
                      >
                        {savedPlanGroups.map((item, index) => {
                          return (
                            <MappedPlanGroupCard
                              item={item}
                              onPlanGroupClick={onPlanGroupClick}
                              savedPlanGroups={savedPlanGroups}
                              setSavedPlangroups={setSavedPlangroups}
                              setAddedPlanGroups={setAddedPlanGroups}
                              mapType={data?.mapType}
                              dispatch={dispatch}
                            />
                          );
                        })}
                      </div>
                    </div>

                    <MappedPlanGroupSlider
                      slideout={slideout}
                      setSlideOut={setSlideOut}
                      planGroupId={planGroupId}
                    />
                  </div>
                )}
              </LoaderWrapper>
            </ManageMapperLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default LoadDefHomeContainer;
